import React from 'react'
import Login from  '../../Components/Login/Login.jsx'
const login = () => {
  return (
    <>
      <Login/>
      </> 
  )
}

export default login